import request from '@/utils/request'

const base ='/db/storage-apply-info'

export function queryRequest(data) {
    return request({
        url: base+'/page-query',
        method: 'post',
        data
    })
}

export function materialTemplate() {
    return request({
        url: base+'/material-template',
        method: 'get',
    })
}

export function materialImport(data) {
    return request({
        url: base+'/material-info',
        method: 'post',
        data
    })
}

export function ossUpload(data) {
    return request({
        url: base+'/oss-file-upload',
        method: 'post',
        data
    })
}

export function getCkInboundNo() {
    return request({
        url: '/db/sequence/getCkInboundNo',
        method: 'get',
    })
}

export function getKyInboundNo() {
    return request({
        url: '/db/sequence/getKyInboundNo',
        method: 'get',
    })
}

export function storageApply(data) {
    return request({
        url: base,
        method: 'post',
        data
    })
}

export function storageHandle(data) {
    return request({
        url: base+'/handle',
        method: 'post',
        data
    })
}

export function storageRefuse(data) {
    return request({
        url: base+'/refuse',
        method: 'post',
        data
    })
}

export function queryEqpProdList(data) {
    return request({
        url: '/db/material-info'+'/queryEqpProdList',
        method: 'post',
        data
    })
}

export function details(data){
    return request({
        url:base+'/details',
        method:'post',
        data
    })
}

// 出库记录一键导出
export function reportExport(data){
    return request({
        url:base+'/sotrage-apply-report-export',
        method:'post',
        data
    })
}
